/*
<template>
	<div class="w-100 h-100">
		<sf-card class="w-100 h-100">
			<bar-chart :height="180" ref="grpBar" :chartData="datacollection" :options="options" />
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	components: {
		BarChart: Chart.BarChart
	},
	created() {
		this.options.scales.yAxes[0].ticks.suggestedMax = this.maxCnt;
	},
	data() {
		return {
			options: {
				//chart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					xAxes: [
						{
							stacked: false
						}
					],
					yAxes: [
						{
							stacked: false,
							ticks: {
								beginAtZero: true,
								suggestedMax: 100,
								suggestedMin: 0
							}
						}
					]
				}
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection() {
			return {
				labels: this.stackedLabel_,
				datasets: this.stackedDataSet_
			};
		}
	}, //end cu
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
